module.exports = __webpack_public_path__ + "static/media/sad.2de1caa7.svg";